import axios from 'axios'

export const brokerApi = axios.create({
  baseURL: import.meta.env.VITE_BROKER_BASE_URL ?? '',
  withCredentials: true,
  headers: { 'Content-Type': 'application/json' },
})

brokerApi.interceptors.request.use((config) => {
  const token = localStorage.getItem('session_token')
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
})
